import SelectField from '@/components/ui/form-inputs/SelectField';
import { USER_FORM_KEY } from '@/shared/constants/form-keys';
import { ChangeEvent, FunctionComponent, ReactElement } from 'react';
import { CommonSiteSelectProps } from './types';

const SiteSingleSelect: FunctionComponent<CommonSiteSelectProps> = ({
	formModel,
	updateFormModel,
	sites,
	disabled = false,
}): ReactElement => (
	<SelectField
		id="sites"
		name="sites"
		label="Sites"
		formKey={USER_FORM_KEY}
		fullWidth
		required
		value={formModel?.sites?.[0] ?? ''}
		onChange={(event: ChangeEvent<HTMLInputElement>) =>
			updateFormModel({ ...formModel, sites: [event.target.value] })
		}
		options={sites?.map((site) => ({ value: site.id, label: site.name }))}
		disabled={disabled}
	/>
);

export default SiteSingleSelect;
